module.exports = __webpack_public_path__ + "img/1.68bd223c.jpg";